var map = {
	"./404.svg": "sEM+",
	"./adjust.svg": "m4eJ",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./delete.svg": "Imjp",
	"./development-manage.svg": "o4sW",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./goods-manage.svg": "tSe2",
	"./icon.svg": "vUvT",
	"./img-validcode.svg": "Eh/y",
	"./international.svg": "SBEl",
	"./item-drag.svg": "oo//",
	"./language.svg": "+Dip",
	"./list-move.svg": "58Hk",
	"./live-manage.svg": "e+f0",
	"./lock.svg": "FnAU",
	"./member-manage.svg": "+P/0",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./order-manage.svg": "Zw2k",
	"./page-manage.svg": "2vek",
	"./password.svg": "QjmH",
	"./pen-leather.svg": "0B+7",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./promotions-manage.svg": "nK2o",
	"./qq.svg": "R2jY",
	"./right-angle.svg": "WSQw",
	"./send.svg": "0zCS",
	"./setting-manage.svg": "XXqu",
	"./shop-manage.svg": "+5Lc",
	"./shoppingCard.svg": "dNDk",
	"./star.svg": "60zo",
	"./statistics-manage.svg": "Hw+N",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tool.svg": "Y44e",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 101